var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42 408h23v-.72-72.28-42h-31v42 72h-23v27h31z",
    fill: "#d4e1f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m452.718 78.065-40.549-7.009a6 6 0 0 0 -2.044 11.824l26.93 4.655-176.31 123.265-100.345-53a6.005 6.005 0 0 0 -6.784.817l-106.277 94.258a6 6 0 0 0 7.963 8.978l103.165-91.5 99.912 52.771a6 6 0 0 0 6.24-.388l178.581-124.858-4.43 25.625a6 6 0 1 0 11.825 2.044l7.013-40.547a6 6 0 0 0 -4.89-6.935z",
    fill: "#1ae5be"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m501 402h-7v-244.166a5.821 5.821 0 0 0 -5.953-5.834h-54.033a5.873 5.873 0 0 0 -6.014 5.834v244.166h-34v-179.679a6.18 6.18 0 0 0 -5.878-6.321h-54.033a6.358 6.358 0 0 0 -6.089 6.321v179.679h-34v-148.652c0-3.314-2.488-6.348-5.8-6.348h-54.035a6.448 6.448 0 0 0 -6.165 6.348v148.652h-34v-178.728a6.272 6.272 0 0 0 -6.272-6.272h-53.488a6.258 6.258 0 0 0 -6.24 6.24v67.76a6 6 0 0 0 12 0v-20h42v131h-42v-69a6 6 0 0 0 -12 0v69h-34v-108.652c0-3.314-2.337-6.348-5.651-6.348h-54.033a6.582 6.582 0 0 0 -6.316 6.348v108.652h-17a5.708 5.708 0 0 0 -6 5.646v27.386a5.972 5.972 0 0 0 6 5.968h490a5.972 5.972 0 0 0 6-5.968v-27.386a5.708 5.708 0 0 0 -6-5.646zm-361-143v-30h42v30zm342-95v30h-42v-30zm-42 42h42v196h-42zm-58 22v30h-42v-30zm-42 42h42v132h-42zm-58-11v30h-42v-30zm-42 42h42v101h-42zm-158-2v30h-42v-30zm-42 42h42v61h-42zm455 88h-478v-15h478z",
    fill: "#0635c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.d9b91fa1779cd89710b3ce153dcc9847.svg";
export { ForwardRef as ReactComponent };